import * as React from 'react'
import { ReactElement } from 'react'
import useTaskStatuses from '../../hooks/useTaskStatuses'
import BaseTagPicker, { BaseTagPickerProps } from './BaseTagPicker'
import { TaskStatus } from '../../context/GlobalContext'

export type TaskStatusPickerProps = Partial<BaseTagPickerProps<TaskStatus>> &
    Required<Pick<BaseTagPickerProps<TaskStatus>, 'selectedOptions' | 'onOptionsSelect'>>

export default function TaskStatusPicker(props: TaskStatusPickerProps): ReactElement {
    const { taskStatuses, getStatusName } = useTaskStatuses()

    return (
        <BaseTagPicker<TaskStatus>
            entities={taskStatuses}
            getEntityValue={status => status.alpha}
            getEntityTagLabel={status => getStatusName(status.alpha)}
            getEntityLabel={status => getStatusName(status.alpha)}
            placeholderKey={'base.taskstatuscombobox.placeholder'}
            {...props}
        />
    )
}
